module.exports = __webpack_public_path__ + "img/font-size-increase-icon.9d57fb64.svg";